export default __webpack_public_path__ + "static/banner-c7b4634340c6b6b1e58e8a49cf477863.jpg";